import type { ComponentType } from 'react'
import { lazy } from 'react'

const CHUNK_REFRESH_KEY = 'sputnik-chunk-refresh'

/**
 * Drop-in replacement for React.lazy that recovers from stale-hash chunk 404s
 * after a deploy: the first failed import hard-reloads the page (fresh
 * index.html -> fresh chunk hashes). A sessionStorage guard prevents a reload
 * loop, so a second failure rethrows and surfaces through PageErrorBoundary.
 */
const lazyRetry = <T extends ComponentType<any>>(importComponent: () => Promise<{ default: T }>) =>
  lazy(async () => {
    try {
      const component = await importComponent()
      window.sessionStorage.removeItem(CHUNK_REFRESH_KEY)
      return component
    } catch (error) {
      if (!window.sessionStorage.getItem(CHUNK_REFRESH_KEY)) {
        window.sessionStorage.setItem(CHUNK_REFRESH_KEY, 'true')
        window.location.reload()
        return new Promise<never>(() => {})
      }
      throw error
    }
  })

export default lazyRetry
